import { resolveApiUrl } from "~/utils/url/urlResolver";
import { getCsrfValue } from "~/api/ApiHelper";

const BASE_URL = resolveApiUrl("/registered/user/exists");
export async function apiUserExists(email: string): Promise<boolean> {
  const url = encodeURI(`${BASE_URL}/${email}`);
  const response = await fetch(url, {
    method: "GET",
    headers: {
      dataType: "json",
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  });

  const data = await response.json();
  return data;
}
